import { LoadingIcon, classNames } from '@panwds/react-ui'
import { useMemo } from 'react'

const ScreenLoader = ({ appearance = 'dark', transparent = true }) => {

  const className = useMemo<string>(() => {
    return classNames(
      'tw-fixed',
      'tw-inset-0',
      'tw-flex',
      'tw-justify-center',
      'tw-items-center',
      'tw-z-50',
      transparent ? 'tw-bg-opacity-50' : '',
      appearance === 'dark' ? 'tw-bg-black' : 'tw-bg-gray-200',
    )
  }, [appearance, transparent])

  return (
    <div
      className={className} >
      <LoadingIcon size="4xl" />
    </div>
  )
}

export default ScreenLoader
